(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire04f6"];
var parcelRegister = parcelRequire.register;
parcelRegister("l2msb", function(module, exports) {

$parcel$export(module.exports, "showNotification", function () { return $f50b33aca851fa1b$export$f7dc72e91f29c7d7; });

var $cYr9j = parcelRequire("cYr9j");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $amul4 = parcelRequire("amul4");

var $1Mpn7 = parcelRequire("1Mpn7");

var $eP3xl = parcelRequire("eP3xl");
var $f50b33aca851fa1b$var$AlertNotification = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $dcsZi._)(AlertNotification, _React_Component);
    function AlertNotification() {
        (0, $4GJKx._)(this, AlertNotification);
        return (0, $cYr9j._)(this, AlertNotification, arguments);
    }
    (0, $1wc17._)(AlertNotification, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var that = this;
                setTimeout(function() {
                    that.onClose();
                }, 7000);
            }
        },
        {
            key: "onClose",
            value: function onClose() {
                var AlertnotificationDOM = document.getElementById("alert-notification");
                (0, (/*@__PURE__*/$parcel$interopDefault($eP3xl))).unmountComponentAtNode(AlertnotificationDOM);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, title = _this_props.title, message = _this_props.message, type = _this_props.type;
                return /*#__PURE__*/ (0, $amul4.jsx)("div", {
                    className: "AlertNotification",
                    children: /*#__PURE__*/ (0, $amul4.jsxs)("div", {
                        className: "".concat(type, " notification"),
                        children: [
                            /*#__PURE__*/ (0, $amul4.jsx)("img", {
                                className: "close-notification",
                                src: "".concat(BASE.url, "v4/image/notification/close.svg"),
                                onClick: function() {
                                    return _this.onClose();
                                }
                            }),
                            /*#__PURE__*/ (0, $amul4.jsxs)("div", {
                                className: "icon-title",
                                children: [
                                    /*#__PURE__*/ (0, $amul4.jsx)("img", {
                                        className: "icones",
                                        "data-src": " "https://assets.alsoug.com/v4/image/notification/note.svg"
                                    }),
                                    /*#__PURE__*/ (0, $amul4.jsx)("p", {
                                        className: "title",
                                        children: title
                                    })
                                ]
                            }),
                            message ? /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                className: "message",
                                children: /*#__PURE__*/ (0, $amul4.jsx)("p", {
                                    children: message
                                })
                            }) : null
                        ]
                    })
                });
            }
        }
    ]);
    return AlertNotification;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Component);
function $f50b33aca851fa1b$export$f7dc72e91f29c7d7(param) {
    var title = param.title, message = param.message, type = param.type;
    var Alertnotification = document.getElementById("alert-notification");
    if (Alertnotification) (0, (/*@__PURE__*/$parcel$interopDefault($eP3xl))).render(/*#__PURE__*/ (0, $amul4.jsx)($f50b33aca851fa1b$var$AlertNotification, {
        title: title,
        type: type,
        meesage: message
    }), Alertnotification);
}

});

})();
//# sourceMappingURL=notification.4a69876a.js.map
